import { Link, useLocation } from 'react-router-dom';
import { FiX } from 'react-icons/fi';
import { useAuth } from '../contexts/AuthContext';
import { MENU_SECTIONS } from '../config/menuCatalog';

const Sidebar = ({ isOpen, toggleSidebar, isCollapsed }) => {
  const location = useLocation();
  const { user } = useAuth();
  const canAccessAllSites = Boolean(user?.canAccessAllSites);
  const role = user?.role;
  const menuKeys = Array.isArray(user?.menu_keys) ? user.menu_keys : [];

  const canShowItem = (item) => {
    if (!item.roles.includes(role)) return false;
    if (item.globalOnly && !canAccessAllSites) return false;
    // SuperAdmin always sees their allowed roles' menu items
    if (role === 'SuperAdmin') return true;
    return menuKeys.includes(item.menuKey);
  };

  const filteredSections = MENU_SECTIONS
    .map((section) => ({
      ...section,
      items: section.items.filter(canShowItem),
    }))
    .filter((section) => section.items.length > 0);

  const isItemActive = (path) => {
    if (location.pathname === path) return true;
    if (path !== '/dashboard' && location.pathname.startsWith(`${path}/`)) return true;
    return false;
  };

  return (
    <>
      {isOpen && <div className="fixed inset-0 bg-black bg-opacity-50 z-[998] lg:hidden" onClick={toggleSidebar} />}

      <aside
        className={`fixed left-0 top-0 h-screen w-[240px] bg-slate-950 text-white z-[999] flex flex-col border-r border-slate-800 transition-all duration-300 ease-in-out ${isCollapsed ? 'lg:w-16' : 'lg:w-[240px]'} ${
          isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'
        }`}
      >
        <div className="px-4 py-4 relative">
          <div className="flex flex-col items-center gap-2">
            <img
              src={isCollapsed ? '/favicon.png' : '/logo.png'}
              alt="GPACS SYSTEM"
              className={`${isCollapsed ? 'w-8' : 'w-28'} h-auto object-contain`}
            />
            {!isCollapsed && (
              <span className="text-[11px] font-semibold tracking-widest text-center text-slate-400 uppercase">GPACS SYSTEM</span>
            )}
          </div>
          <button
            className="lg:hidden absolute top-2 right-2 bg-transparent border-none text-white text-2xl cursor-pointer p-2 rounded-md transition-colors hover:bg-slate-800"
            onClick={toggleSidebar}
            title="Đóng menu"
          >
            <FiX />
          </button>
        </div>

        <nav className="flex-1 py-4 overflow-y-auto sidebar-scroll">
          {filteredSections.map((section) => (
            <div key={section.title} className="mb-4">
              {!isCollapsed && (
                <div className="px-4 pb-1.5 text-[11px] uppercase tracking-wider text-slate-500 font-semibold">
                  {section.title}
                </div>
              )}

              <div className="space-y-1 px-2.5">
                {section.items.map((item) => {
                  const Icon = item.icon;
                  const isActive = isItemActive(item.path);

                  return (
                    <Link
                      key={item.path}
                      to={item.path}
                      title={item.label}
                      className={`flex items-center py-2.5 px-3 text-slate-300 transition-colors relative rounded-lg ${
                        isActive
                          ? 'bg-primary text-white shadow-sm shadow-primary/20'
                          : 'hover:bg-slate-900 hover:text-white'
                      } ${
                        isCollapsed ? 'justify-center' : ''
                      }`}
                      onClick={() => {
                        if (window.innerWidth < 1024) toggleSidebar();
                      }}
                    >
                      <Icon className={`text-base ${isCollapsed ? '' : 'mr-2'} ${isActive ? 'text-white' : 'text-slate-400'}`} />
                      {!isCollapsed && <span className="font-medium text-sm">{item.label}</span>}
                    </Link>
                  );
                })}
              </div>
            </div>
          ))}
        </nav>

      </aside>
    </>
  );
};

export default Sidebar;
